import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./Motion";
import { PHONE_DISPLAY, PHONE_HREF } from "../../data/content";

export const CtaBand = () => (
  <section className="bg-[#FDFBF7] px-3 pb-3 sm:px-5 sm:pb-5" data-testid="cta-band">
    <div className="grain relative overflow-hidden rounded-[2rem] bg-[#C86D51] sm:rounded-[2.5rem]">
      <img src="/images/hero.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25 mix-blend-multiply" />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-6 py-20 sm:px-10 lg:grid-cols-12 lg:items-end lg:px-12 lg:py-28">
        <Reveal className="lg:col-span-8">
          <Eyebrow light className="!text-[#FDE7DD]">When you're ready</Eyebrow>
          <h2 className="font-serif-display mt-4 text-5xl leading-[0.98] tracking-tight text-[#FDFBF7] sm:text-7xl">
            One conversation <br className="hidden sm:block" /><span className="italic">can change the direction.</span>
          </h2>
        </Reveal>
        <Reveal className="flex flex-col gap-3 lg:col-span-4" delay={0.1}>
          <Link to="/contact" className="group flex items-center justify-between rounded-full bg-[#1B241E] px-7 py-4 text-sm font-medium text-[#F4F1EA] transition-colors hover:bg-[#FDFBF7] hover:text-[#1B241E]" data-testid="cta-contact-button">
            Reach out today <ArrowUpRight className="h-5 w-5 transition-transform group-hover:rotate-45" />
          </Link>
          <a href={PHONE_HREF} className="flex items-center justify-between rounded-full border border-[#FDFBF7]/60 px-7 py-4 text-sm font-medium text-[#FDFBF7] transition-colors hover:bg-[#FDFBF7]/10" data-testid="cta-phone-link">
            Call {PHONE_DISPLAY} <Phone className="h-4 w-4" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
